const actionsTypesOneQuestion={
    LOAD_SUCCESS_QUESTION:"LOAD_SUCCESS_QUESTION",
    LOAD_FAILURE_QUESTION:"LOAD_FAILURE_QUESTION",
    LOADING_QUESTION:"LOADING_QUESTION",
    DELETE_ANSWER:"DELETE_ANSWER",
}

export default actionsTypesOneQuestion